var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Viewer,{ref:"viewer",staticClass:"TuiViewer",style:(`height: ${_vm.height}; overflow: ${_vm.overflow};`),attrs:{"initialValue":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }